import { useEffect, useState } from "react";
import { DESCRIPTION_OF_DIAGNOSIS_MAX_LENGTH, FORM_KEYS, isMaternity } from "./helper";
import AsteriskSymbol from "../../../../reusableComponents/AsteriskSymbol";
import Select from 'react-select';
import Accordion from 'react-bootstrap/Accordion';
import CustomMultiSelect from "../../../../reusableComponents/CustomMultiSelect";
import { REGEX } from "../../../../consts";
import DateAndTime from "../../../../utilsComponent/DateAndTime";
import { fetchDistricts, fetchMandals } from "../../../apiHelper";
import { getLocationDetailsBasedOnPincode, getLocationDetailsBasedOnVillageId } from "./apiHelper";
import { toast } from "react-toastify";
import { axiosRequest } from "../../../../service";
import { REACT_APP_VAM_CONTEXT_MASTER, REACT_APP_VAM_ENDPOINT } from "../../../../urls";
import LoadingPage from "../../../../reusableComponents/loader/loadingPage";

export const OTHERS = "Others"

const HospitalizationDetails = ({
    customStyles,
    formData,
    setValue,
    setHospitalizationDetails,
    setFormData,
    defaultHospitalizationDetails,
    hospitalizationReasons,
    statesList,
    ailmentList,
    isDisabled,
    isSubmit,
    handleAddEditHospital,
    isIncident,
    previousHospitalDischargeTime,
    previousHospitalDischargeDate
}) => {
    const [hospitalList, setHospitalList] = useState([]);
    const [villageList, setVillageList] = useState([])
    const [enableAdd, setEnableAdd] = useState(false)
    const [districtList, setDistrictList] = useState([]);
    const [mandalList, setMandalList] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const getDistrictList = async (state) => {
        const fetchedDistricts = await fetchDistricts(state);
        setDistrictList(fetchedDistricts);
    };
    

    const getMandalList = async (district, state) => {
        if (district && state) {
            const fetchedMandals = await fetchMandals(district, state);
            setMandalList(fetchedMandals);
        }
    };
    const getHospitalsList= async (pincode,index)=>{
          axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_MASTER}/health/hospitals?pincode=${pincode}`)
                .then(response => {
                    const hospitals = response?.data?.hospitalList?.map(hospital => ({
                        value: hospital,
                        label: hospital?.hospitalName || "Others"
                    })) || [];
                    hospitals.push({ value: "Others", label: "Others" });
                    setHospitalList(hospitals);
                    setHospitalizationDetails(index, FORM_KEYS.hospital, null)
                })
                .catch(error => {
                    console.log('Error fetching states:', error);
                });
    }
   
    const onPincodeChange = async (pincode, index) => {
        const numericValue = pincode.replace(REGEX.NUMBER, '');
        pincode = numericValue;
        setHospitalizationDetails(index, FORM_KEYS.pincode, pincode)
        setHospitalizationDetails(index, FORM_KEYS.hospital_city_and_pincode, null);
        setHospitalizationDetails(index, FORM_KEYS.state, null);
        setHospitalizationDetails(index, FORM_KEYS.district, null);
        setHospitalizationDetails(index, FORM_KEYS.mandal, null);
        setHospitalizationDetails(index, FORM_KEYS.village, null);
        setHospitalList([])
        setVillageList([])
        setHospitalizationDetails(index, FORM_KEYS.hospital, null)
        if (pincode.length === 6) {
            //call the API for location details
            setIsLoading(true)
            const response = await getLocationDetailsBasedOnPincode(pincode)
            await getHospitalsList(pincode,index)
            setIsLoading(false)
            // set the options for village
            const options = response?.map(village => {
                return {
                    value: village,
                    // label: village.vname+ ", "+ village.vmandal+ ", "+ village.vdistrict +"(Dist)"
                    label: village.vname
                }
            })
            setVillageList(options)
        }
    }

    const handleHospitalChange =async (data, index) => {
        setHospitalizationDetails(index, FORM_KEYS.hospital, data)
        setHospitalizationDetails(index, FORM_KEYS.hospital_name, "")
        if (data.value === OTHERS) {
            setHospitalizationDetails(index, FORM_KEYS.hospital_city_and_pincode, null);
            setHospitalizationDetails(index, FORM_KEYS.hospital_city_and_pincode, null);
            setHospitalizationDetails(index, FORM_KEYS.state, null);
            setHospitalizationDetails(index, FORM_KEYS.district, null);
            setHospitalizationDetails(index, FORM_KEYS.mandal, null);
            setHospitalizationDetails(index, FORM_KEYS.village, null);
        } else {
            setIsLoading(true);
            const response = await getLocationDetailsBasedOnVillageId(data.value.villageId)
            setIsLoading(false)
            setHospitalizationDetails(index, FORM_KEYS.state, { value: response?.stateId, label: response?.stateName})
            setHospitalizationDetails(index, FORM_KEYS.district, { value: response?.districtId, label: response?.districtName })
            setHospitalizationDetails(index, FORM_KEYS.mandal, { value: response?.mandalId, label: response?.mandalName })
            setHospitalizationDetails(index, FORM_KEYS.village, { value: response?.villageId, label: response?.villageName })
        }

    }

    const handleSave = (index) => {
        const details = formData?.hospitalizationDetails[index];
        const dateOfIncidence = formData?.[FORM_KEYS.date_of_incidence]
        const timeOfIncidence = formData?.[FORM_KEYS.time_of_incidence]
        const dateOfAdmission = details[FORM_KEYS.date_of_admission];
        const timeOfAdmission = details[FORM_KEYS.time_of_admission];
        const dateOfDischarge=details[FORM_KEYS.date_of_discharge]
        const timeOfDischarge=details[FORM_KEYS.time_of_discharge]
        const state = details[FORM_KEYS.state];
        const district = details[FORM_KEYS.district];
        const mandal = details[FORM_KEYS.mandal];
        const hospital = details[FORM_KEYS.hospital];
        const hospitalName = details[FORM_KEYS.hospital_name]?.trim();
        const reasonForHospitalization = details[FORM_KEYS.reason_of_hospitalization];
        const ailment = details[FORM_KEYS.ailment];
        const doctorMobileNumber = details[FORM_KEYS.doctor_mobile_number]?.trim();
        const doctorName = details[FORM_KEYS.doctor_name]?.trim()
        if(isDisabled){
            if(dateOfDischarge && !timeOfDischarge){
                setEnableAdd(false)
            }else setEnableAdd(true)
        }else if (
            (!isIncident && (
            !dateOfIncidence ||
            !timeOfIncidence
            )) || 
            !dateOfAdmission ||
            !timeOfAdmission ||
            !state ||
            !district ||
            !mandal ||
            !hospital ||
            (hospital && hospital?.value === OTHERS && !hospitalName) ||
            !reasonForHospitalization ||
            (!isMaternity(reasonForHospitalization?.label) && !ailment )||
            !doctorName ||
            (doctorMobileNumber && doctorMobileNumber.length != 10) ||
            (!isIncident && (
                !dateOfDischarge || 
                !timeOfAdmission 
            ))
        ) {
            setEnableAdd(false)
        } else {
            if (dateOfDischarge && !timeOfDischarge) setEnableAdd(false)
            else setEnableAdd(true)
        }

    }
    const checkDate = (date, time) => {
        if (date) {
            const incidenceDateRaw = date;
            const incidenceTimeRaw = time;
            const updatedHospitalizationDetails = formData.hospitalizationDetails.map((data) => {
                const admissionDateRaw = data?.[FORM_KEYS.date_of_admission];
                const admissionTimeRaw = data?.[FORM_KEYS.time_of_admission];

                // const admissionDate = admissionDateRaw ? new Date(admissionDateRaw).getTime() : null;
                
                const admissionDate = admissionDateRaw
                                ? new Date(`${admissionDateRaw}${admissionTimeRaw ? 'T' + admissionTimeRaw : ''}`).getTime()
                                : null;

                // const incidenceDate = incidenceDateRaw ? new Date(incidenceDateRaw).getTime() : null;
                const incidenceDate = incidenceDateRaw
                                ? new Date(`${incidenceDateRaw}${incidenceTimeRaw ? 'T' + incidenceTimeRaw : '00:00:00'}`).getTime()
                                : null
                if (admissionDate && incidenceDate && admissionDate < incidenceDate) {
                    // Clear fields if admission is before incidence
                    return {
                        ...data,
                        [FORM_KEYS.date_of_admission]: "",
                        [FORM_KEYS.time_of_admission]: "",
                    };
                }
                return data;
            });
            setValue("hospitalizationDetails", updatedHospitalizationDetails)
            setValue(FORM_KEYS.date_of_incidence, incidenceDateRaw)
            setValue(FORM_KEYS.time_of_incidence, incidenceTimeRaw)
        }
    };
    const validateHospitalizationDates = (index, date, time, isDischarge) => {  
        if (date) {            
            const dischargeDateRaw = isDischarge ? date : formData?.hospitalizationDetails?.[index]?.[FORM_KEYS.date_of_discharge];
            const dischargeTimeRaw = isDischarge ? time : formData?.hospitalizationDetails?.[index]?.[FORM_KEYS.time_of_discharge];
            const prevHospitalDischargeDateRaw = index> 0 ? formData?.hospitalizationDetails?.[index-1]?.[FORM_KEYS.date_of_discharge]: previousHospitalDischargeDate ? previousHospitalDischargeDate : "";
            const prevHospitalDischargeTimeRaw = index> 0 ? formData?.hospitalizationDetails?.[index-1]?.[FORM_KEYS.time_of_discharge]: previousHospitalDischargeTime ? previousHospitalDischargeTime : "";
            const nextHospitalAdmissionDateRaw = formData.hospitalizationDetails?.length > index + 1 ? formData?.hospitalizationDetails?.[index + 1]?.[FORM_KEYS.date_of_admission] : "";
            const nextHospitalAdmissionTimeRaw = formData.hospitalizationDetails?.length > index + 1 ? formData?.hospitalizationDetails?.[index + 1]?.[FORM_KEYS.time_of_admission]:"";
            const admissionDateRaw = isDischarge ? formData?.hospitalizationDetails?.[index]?.[FORM_KEYS.date_of_admission]:  date;
            const admissionTimeRaw = isDischarge ? formData?.hospitalizationDetails?.[index]?.[FORM_KEYS.time_of_admission]:  time;
            const incidenceDateRaw = formData[FORM_KEYS.date_of_incidence]
            const incidenceTimeRaw = formData[FORM_KEYS.time_of_incidence]
            const incidenceDate = incidenceDateRaw
                                ? new Date(`${incidenceDateRaw}T${incidenceTimeRaw ? incidenceTimeRaw : '00:00:00'}`).getTime()
                                : null;
            const prevHospitalDischargeDate = prevHospitalDischargeDateRaw ? new Date(`${prevHospitalDischargeDateRaw}T${prevHospitalDischargeTimeRaw ? prevHospitalDischargeTimeRaw : '00:00:00'}`).getTime() : null;
            const nextHospitalAdmissionDate = nextHospitalAdmissionDateRaw ? new Date(`${nextHospitalAdmissionDateRaw}T${nextHospitalAdmissionTimeRaw ? nextHospitalAdmissionTimeRaw : '00:00:00'}`).getTime() : null;
            const admissionDate = admissionDateRaw
                ? new Date(`${admissionDateRaw}T${admissionTimeRaw ? admissionTimeRaw : '00:00:00'}`)
                : null;
            const dischargeDate = dischargeDateRaw ? new Date(`${dischargeDateRaw}T${dischargeTimeRaw ? dischargeTimeRaw : '23:59:59'}`).getTime() : null;           
            // Check if discharge is before admission
            if (isDischarge) {
                if (dischargeDate && admissionDate && dischargeDate < admissionDate) {
                    toast.error("Date & Time of Discharge should be after Date & Time of Admission")
                } else {
                    if (formData.hospitalizationDetails?.length > index + 1 && nextHospitalAdmissionDate && dischargeDate && nextHospitalAdmissionDate < dischargeDate) {
                        setHospitalizationDetails(index + 1, FORM_KEYS.date_of_admission, "")
                        setHospitalizationDetails(index + 1, FORM_KEYS.time_of_admission, "")
                    }
                    setHospitalizationDetails(index, FORM_KEYS.date_of_discharge, dischargeDateRaw)
                    setHospitalizationDetails(index, FORM_KEYS.time_of_discharge, dischargeTimeRaw)
                }
            } else {
                if(admissionDate && incidenceDate && admissionDate < incidenceDate && admissionTimeRaw) {
                    toast.error("Date & Time of Admission should be after Date & Time of Incidence")
                    setHospitalizationDetails(index, FORM_KEYS.time_of_admission, "")
                } else if( (index> 0 || prevHospitalDischargeDate) && prevHospitalDischargeDate>admissionDate && admissionTimeRaw) {
                    toast.error("Date & Time of Admission should be after previous hospital Date & Time of Discharge")
                    setHospitalizationDetails(index, FORM_KEYS.time_of_admission, "")
                } else {
                    setHospitalizationDetails(index, FORM_KEYS.date_of_admission, admissionDateRaw )
                    setHospitalizationDetails(index, FORM_KEYS.time_of_admission, admissionTimeRaw)
                    if(dischargeDate < admissionDate) {
                        setHospitalizationDetails(index, FORM_KEYS.date_of_discharge, "")
                        setHospitalizationDetails(index, FORM_KEYS.time_of_discharge, "")
                        if(formData.hospitalizationDetails?.length > index + 1 && nextHospitalAdmissionDate){
                            setHospitalizationDetails(index + 1, FORM_KEYS.date_of_admission, "")
                            setHospitalizationDetails(index + 1, FORM_KEYS.time_of_admission, "")
                        }
                    }
                }
            }

            
        }
    };

    const handleAddHospital = () => {
        setFormData((prev) => ({
            ...prev,
            hospitalizationDetails: [...prev.hospitalizationDetails, defaultHospitalizationDetails]
        }));
    }

    const handleDeleteHospital = (indexToDelete) => {
        setFormData((prev) => ({
            ...prev,
            hospitalizationDetails: prev.hospitalizationDetails.filter((_, index) => index !== indexToDelete)
        }));

    }

    useEffect(() => {
        handleSave(formData?.hospitalizationDetails?.length - 1)
    }, [formData])


    return <>
        {isLoading && <LoadingPage kshemaLoader/>}
        <Accordion className='accordion mt-2 mx-2' defaultActiveKey={0}>
            <Accordion.Item eventKey={0}>
                <Accordion.Header>Hospitalization Details</Accordion.Header>
                <Accordion.Body>
                    {!isIncident &&  <div className="row mt-1">
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2">
                            <DateAndTime
                                label={"Date & Time of Incidence"}
                                required
                                date={formData[FORM_KEYS.date_of_incidence]}
                                setDate={(date) => { setValue(FORM_KEYS.date_of_incidence, date); }}
                                time={formData[FORM_KEYS.time_of_incidence]}
                                setTime={(time) => { setValue(FORM_KEYS.time_of_incidence, time);  }}
                                disableFuture
                                maxDate={new Date()}
                                onChange={(date, time) => checkDate(date ||formData[FORM_KEYS.date_of_incidence], time || formData[FORM_KEYS.time_of_incidence])}
                            />
                        </div>
                    </div>
                    } 
                    <div className="mx-1">
                        {formData.hospitalizationDetails?.map((hospitalizationDetails, index) => (
                            <Accordion className='accordion' defaultActiveKey={formData.hospitalizationDetails?.length - 1}>
                                <Accordion.Item eventKey={index}>
                                    <Accordion.Header>
                                        <div className="d-flex justify-content-between align-items-center w-100">
                                            <span>Hospital{!isSubmit && <span>- {index + 1}</span>}</span>
                                            {formData.hospitalizationDetails.length > 1 && (<i
                                                className="fa fa-trash text-danger pe-4 cursor-pointer"
                                                onClick={() => handleDeleteHospital(index)}
                                                title="Delete"
                                            ></i>)}
                                        </div>
                                    </Accordion.Header>

                                    <Accordion.Body>
                                        <div>
                                            <h6 className="mx-2 text-primary">Admitted Details</h6>
                                        </div>
                                        <div className="row mt-1">
                                            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2">
                                                <DateAndTime
                                                    label={"Date & Time of Admission"}
                                                    required
                                                    date={hospitalizationDetails[FORM_KEYS.date_of_admission]}
                                                    setDate={(date) => { setHospitalizationDetails(index, FORM_KEYS.date_of_admission, date)}}
                                                    time={hospitalizationDetails[FORM_KEYS.time_of_admission]}
                                                    setTime={(time) => { setHospitalizationDetails(index, FORM_KEYS.time_of_admission, time)}}
                                                    disableFuture
                                                    isDisabled = {isDisabled || (index !==0 && !formData.hospitalizationDetails[index-1]?.[FORM_KEYS.date_of_discharge])}
                                                    maxDate={new Date()}
                                                    onChange={(date, time) => validateHospitalizationDates(index,date || hospitalizationDetails[FORM_KEYS.date_of_admission], time || hospitalizationDetails[FORM_KEYS.time_of_admission])}
                                                    minDate={!isIncident 
                                                        ? index === 0 ? new Date(formData[FORM_KEYS.date_of_incidence]) : new Date(formData.hospitalizationDetails[index-1]?.[FORM_KEYS.date_of_discharge])
                                                        : previousHospitalDischargeDate ? new Date(previousHospitalDischargeDate) : ""}
                                                />
                                            </div>
                                            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2">
                                                <DateAndTime
                                                    label={"Date & Time of Discharge"}
                                                    date={hospitalizationDetails[FORM_KEYS.date_of_discharge]}
                                                    setDate={(date) => { 
                                                        setHospitalizationDetails(index, FORM_KEYS.date_of_discharge, date)
                                                        if(!date && formData.hospitalizationDetails?.length > index + 1) {
                                                            setHospitalizationDetails(index, FORM_KEYS.date_of_discharge, "")
                                                            setHospitalizationDetails(index, FORM_KEYS.time_of_discharge, "")
                                                        }
                                                    }}
                                                    time={hospitalizationDetails[FORM_KEYS.time_of_discharge]}
                                                    setTime={(time) => { setHospitalizationDetails(index, FORM_KEYS.time_of_discharge, time) }}
                                                    disableFuture
                                                    maxDate={new Date()}
                                                    minDate={new Date(hospitalizationDetails[FORM_KEYS.date_of_admission])}
                                                    onChange={(date, time) => validateHospitalizationDates(index,date || hospitalizationDetails[FORM_KEYS.date_of_discharge], time || hospitalizationDetails[FORM_KEYS.time_of_discharge],true)}
                                                />
                                            </div>
                                        </div>
                                        <div className="row mt-1">
                                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2">
                                                <p className="align3Policy">No. of Days in ICU</p>
                                                <input
                                                     type="tel"
                                                    className="claim-intimator-textarea mt-2 ms-2"
                                                    name="tel"
                                                    id="tel"
                                                    placeholder="Enter No. of Days in ICU"
                                                    onChange={(e) => {
                                                        const numericValue = e.target.value.replace(/[^0-9.,]/g, '');
                                                        if (!isNaN(numericValue) && +(numericValue) >= 0) {
                                                            setHospitalizationDetails(index, FORM_KEYS.icu_days, numericValue)
                                                        }
                                                    }}
                                                    value={hospitalizationDetails[FORM_KEYS.icu_days]}
                                                />
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2">
                                                <p className="align3Policy">No. of Days in Non-ICU</p>
                                                <input
                                                    type="tel"
                                                    className="claim-intimator-textarea mt-2 ms-2"
                                                    name="tel"
                                                    id="tel"
                                                    placeholder="Enter No. of Days in Non-ICU"
                                                    onChange={(e) => {
                                                        const numericValue = e.target.value.replace(/[^0-9.,]/g, '');
                                                        if (!isNaN(numericValue) && +(numericValue) >= 0) {
                                                            setHospitalizationDetails(index, FORM_KEYS.non_icu_days, numericValue)
                                                        }
                                                    }}
                                                    value={hospitalizationDetails[FORM_KEYS.non_icu_days]}
                                                />
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2">
                                                <p className="align3Policy">Total No. of Days in Hospital</p>
                                                <input
                                                    className="claim-intimator-textarea mt-2 ms-2"
                                                    placeholder="Total No. of Days in Hospital"
                                                    value={hospitalizationDetails[FORM_KEYS.icu_days] || hospitalizationDetails[FORM_KEYS.non_icu_days] ? +(hospitalizationDetails[FORM_KEYS.icu_days]) + +(hospitalizationDetails[FORM_KEYS.non_icu_days]) : "--"}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="mt-3">
                                            <h6 className="mx-2 text-primary">Hospital Detail</h6>
                                        </div>
                                      

                                        <div className="row mt-1">
                                              <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2">
                                                    <p className="align3Policy">Enter Pincode <AsteriskSymbol /></p>
                                                    <input
                                                        disabled={isDisabled}
                                                        type="tel"
                                                        className="align3_dataPolicy mt-3 mb-0"
                                                        name="tel"
                                                        id="tel"
                                                        placeholder="Enter pincode"
                                                        maxLength={6}
                                                        onChange={(e) => {
                                                            onPincodeChange(e.target.value, index);
                                                        }}
                                                        value={hospitalizationDetails[FORM_KEYS.pincode]}
                                                    />
                                                </div>
                                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2">
                                                <p className="align3Policy">Hospital Name<AsteriskSymbol /></p>
                                                <Select
                                                    options={hospitalList}
                                                    classNamePrefix="truncate-placeholder"
                                                    placeholder="Select Hospital Name"
                                                    value={hospitalizationDetails[FORM_KEYS.hospital]}
                                                    onChange={(data) => {
                                                        handleHospitalChange(data, index)
                                                    }}
                                                    isDisabled={isDisabled || hospitalizationDetails[FORM_KEYS.pincode]?.length!=6}
                                                    styles={customStyles}
                                                    filterOption={(option, inputValue) => {
                                                        if (option.label === OTHERS) return true;
                                                        return option.label.toLowerCase().includes(inputValue.toLowerCase());
                                                    }}
                                                />
                                            </div>
                                            {hospitalizationDetails[FORM_KEYS.hospital]?.value === OTHERS ? (<>
                                                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2">
                                                    <p className="align3Policy">Enter Hospital Name <AsteriskSymbol /></p>
                                                    <input
                                                        className="claim-intimator-textarea mt-2 ms-2"
                                                        placeholder="Enter Hospital Name "
                                                        value={hospitalizationDetails[FORM_KEYS.hospital_name]}
                                                        maxLength={100}
                                                        onChange={(e) => setHospitalizationDetails(index, FORM_KEYS.hospital_name, e.target.value)}
                                                    />
                                                </div>
                                                
                                                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2">
                                                    <p className="align3Policy">Search Hospital City <AsteriskSymbol /></p>
                                                    <Select
                                                        options={villageList}
                                                        classNamePrefix="truncate-placeholder"
                                                        placeholder="Search Hospital City"
                                                        value={hospitalizationDetails[FORM_KEYS.hospital_city_and_pincode]}
                                                        onChange={(data) => {

                                                            setHospitalizationDetails(index, FORM_KEYS.hospital_city_and_pincode, data)
                                                            // onPincodeChange(e.target.value)
                                                            setHospitalizationDetails(index, FORM_KEYS.state, { value: data.value.sid, label: data.value.vstate })
                                                            setHospitalizationDetails(index, FORM_KEYS.district, { value: data.value.did, label: data.value.vdistrict })
                                                            setHospitalizationDetails(index, FORM_KEYS.mandal, { value: data.value.mid, label: data.value.vmandal })
                                                            setHospitalizationDetails(index, FORM_KEYS.village, { value: data.value.vid, label: data.value.vname })

                                                        }}
                                                        styles={customStyles}
                                                    />
                                                </div>
                                            </>) : ("")}
                                        </div>
                                        <div className="row mt-1">
                                            {/* State */}
                                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2">
                                                <p className="align3Policy">State</p>
                                                <Select
                                                    options={statesList}
                                                    classNamePrefix="truncate-placeholder"
                                                    placeholder="State"
                                                    value={hospitalizationDetails[FORM_KEYS.state]}
                                                    onChange={(data) => {
                                                        setHospitalizationDetails(index, FORM_KEYS.state, data)
                                                        setHospitalizationDetails(index, FORM_KEYS.district, null)
                                                        setHospitalizationDetails(index, FORM_KEYS.mandal, null);
                                                        setHospitalizationDetails(index, FORM_KEYS.hospital, null)
                                                        setHospitalizationDetails(index, FORM_KEYS.hospital_name, "")
                                                        // setHospitalizationDetails(index, FORM_KEYS.hospital_city_and_pincode, "");
                                                        if (data) {
                                                            getDistrictList(data?.value)
                                                        }
                                                    }}
                                                    styles={customStyles}
                                                    isDisabled
                                                />
                                            </div>

                                            {/* District */}
                                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2">
                                                <p className="align3Policy">District</p>
                                                <Select
                                                    options={districtList}
                                                    classNamePrefix="truncate-placeholder"
                                                    placeholder="District"
                                                    value={hospitalizationDetails[FORM_KEYS.district]}
                                                    onChange={(data) => {
                                                        setHospitalizationDetails(index, FORM_KEYS.district, data)
                                                        setHospitalizationDetails(index, FORM_KEYS.mandal, null);
                                                        setHospitalizationDetails(index, FORM_KEYS.hospital, null)
                                                        setHospitalizationDetails(index, FORM_KEYS.hospital_name, "")
                                                        // setHospitalizationDetails(index, FORM_KEYS.hospital_city_and_pincode, "");
                                                        if (data) {
                                                            getMandalList(data?.value, hospitalizationDetails[FORM_KEYS.state]?.value)
                                                        }
                                                    }}
                                                    styles={customStyles}
                                                    isDisabled
                                                />
                                            </div>

                                            {/* Mandal */}
                                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2">
                                                <p className="align3Policy">Mandal</p>
                                                <Select
                                                    options={mandalList}
                                                    classNamePrefix="truncate-placeholder"
                                                    placeholder="Mandal"
                                                    value={hospitalizationDetails[FORM_KEYS.mandal]}
                                                    onChange={(data) => {
                                                        setHospitalizationDetails(index, FORM_KEYS.mandal, data)
                                                        setHospitalizationDetails(index, FORM_KEYS.hospital, null)
                                                        setHospitalizationDetails(index, FORM_KEYS.hospital_name, "")
                                                    }}
                                                    styles={customStyles}
                                                    isDisabled
                                                />
                                            </div>
                                            {/* City / Village / Town */}
                                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2">
                                                <p className="align3Policy">City / Village / Town</p>
                                                <Select
                                                    options={[]}
                                                    classNamePrefix="truncate-placeholder"
                                                    placeholder="City / Village / Town"
                                                    value={hospitalizationDetails[FORM_KEYS.village]}
                                                    styles={customStyles}
                                                    isDisabled
                                                />
                                            </div>
                                        </div>
                                        <div className="mt-3">
                                            <h6 className="mx-2 text-primary">Doctor Details</h6>
                                        </div>
                                        <div className="row mt-1">
                                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2">
                                                <p className="align3Policy">Doctor Name <AsteriskSymbol /></p>
                                                <input
                                                    className="claim-intimator-textarea mt-2 ms-2"
                                                    placeholder="Enter Doctor Name"
                                                    value={hospitalizationDetails[FORM_KEYS.doctor_name]}
                                                    disabled={isDisabled}
                                                    maxLength={100}
                                                    onChange={(e) => setHospitalizationDetails(index, FORM_KEYS.doctor_name, e.target.value)}
                                                />

                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2">
                                                <p className="align3Policy">Doctor Mobile Number</p>
                                                <input
                                                    type="tel"
                                                    className="align3_dataPolicy mt-3"
                                                    name="tel"
                                                    id="tel"
                                                    placeholder="Enter Doctor Mobile Number"
                                                    maxLength={10}
                                                    disabled={isDisabled}
                                                    onChange={(e) => {
                                                        const numericValue = e.target.value.replace(REGEX.NUMBER, '');
                                                        e.target.value = numericValue;
                                                        setHospitalizationDetails(index, FORM_KEYS.doctor_mobile_number, e.target.value)
                                                    }}
                                                    value={hospitalizationDetails[FORM_KEYS.doctor_mobile_number]}
                                                />


                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2">
                                                <p className="align3Policy">Doctor Registration Number</p>
                                                <input
                                                    className="claim-intimator-textarea mt-2 ms-2"
                                                    placeholder="Enter Doctor Registration Number"
                                                    value={hospitalizationDetails[FORM_KEYS.doctor_registration_number]}
                                                    maxLength={50}
                                                    disabled={isDisabled}
                                                    onChange={(e) => setHospitalizationDetails(index, FORM_KEYS.doctor_registration_number, e.target.value)}
                                                />

                                            </div>
                                        </div>
                                        <div className="mt-3">
                                            <h6 className="mx-2 text-primary"> Ailment & Diagnosis Details</h6>
                                        </div>
                                        <div className="row mt-1">
                                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2">
                                                <p className="align3Policy">Reason for Hospitalization <AsteriskSymbol /></p>
                                                <Select
                                                    classNamePrefix="truncate-placeholder"
                                                    options={hospitalizationReasons}
                                                    styles={customStyles}
                                                    isDisabled={isDisabled}
                                                    value={hospitalizationDetails[FORM_KEYS.reason_of_hospitalization] ? hospitalizationDetails[FORM_KEYS.reason_of_hospitalization] : null}
                                                    onChange={(selectedOption) => {
                                                        setHospitalizationDetails(index, FORM_KEYS.reason_of_hospitalization, selectedOption);
                                                        if(selectedOption && isMaternity(selectedOption?.label)) {
                                                            setHospitalizationDetails(index, FORM_KEYS.ailment, null);
                                                        }
                                                    }}
                                                    placeholder="Select Reason for Hospitalization"
                                                />
                                            </div>
                                            {!isMaternity(hospitalizationDetails[FORM_KEYS.reason_of_hospitalization]?.label) && (
                                                <div className="col-xl-9 col-lg-9 col-md-6 col-sm-12">
                                                    <p className="align3Policy ms-2">Ailment <AsteriskSymbol /></p>
                                                    <CustomMultiSelect
                                                        options={ailmentList}
                                                        value={hospitalizationDetails[FORM_KEYS.ailment] ? hospitalizationDetails[FORM_KEYS.ailment] : null}
                                                        onChange={(selectedOption) => {
                                                            if (selectedOption.length === 0) {
                                                                selectedOption = null
                                                            }
                                                            setHospitalizationDetails(index, FORM_KEYS.ailment, selectedOption);
                                                        }}
                                                        placeholder="Select Ailment"
                                                        label={"Ailment"}
                                                        isMulti
                                                        isDisabled={isDisabled}
                                                        classNamePrefix="truncate-placeholder"
                                                        customStyles={customStyles}
                                                        className="ms-2"
                                                        showCountOnly={false}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                        <div className="row mt-1 mx-0">
                                            <div className="col-xl-12 mb-2">
                                                <p className="align3Policy ms-0">Description of Diagnosis</p>
                                                <div>
                                                    <textarea
                                                        className="remarksAccess w-100"
                                                        value={hospitalizationDetails[FORM_KEYS.description_of_diagnosis]}
                                                        disabled={isDisabled}
                                                        onChange={(e) => {
                                                            setHospitalizationDetails(index, FORM_KEYS.description_of_diagnosis, e.target.value?.slice(0, DESCRIPTION_OF_DIAGNOSIS_MAX_LENGTH))
                                                        }
                                                        }>
                                                    </textarea>
                                                    <div className="remarks-text-info w-100">
                                                        <p>{hospitalizationDetails[FORM_KEYS.description_of_diagnosis]?.length}/{DESCRIPTION_OF_DIAGNOSIS_MAX_LENGTH}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            {index === formData.hospitalizationDetails?.length - 1 && (
                                                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2">
                                                    <div className="d-flex gap-2">
                                                        {isSubmit ? <button
                                                            className="btn btn-success"
                                                            onClick={handleAddEditHospital}
                                                            disabled={!enableAdd}
                                                        >
                                                           Submit
                                                        </button>:<button
                                                            className="btn btn-success"
                                                            onClick={handleAddHospital}
                                                            disabled={!enableAdd}
                                                        >
                                                            Add more hospitals
                                                        </button>}
                                                    </div>
                                                </div>)}
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        ))}
                    </div>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    </>
}

export default HospitalizationDetails